import React, { useContext } from "react";
import { connect } from "react-redux";
import { Layout } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import Logo from './Logo';
import { toggleCollapsedNav, onMobileNavToggle } from 'redux/actions/Theme';
import { NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH } from 'constants/ThemeConstant';
import AuthDataContext from "context/AuthDataContext";
import utils from 'utils';
import { useThemeSwitcher } from "react-css-theme-switcher";
import NavProfile from "./NavProfile";
import NavOrgSelector from "./NavOrgSelector";
import NavSettings from "./NavSettings";
import NavNotification from "./NavNotification";
import { FreeTrialIndicator } from "./MenuContent";
import SignInSettingsBanner from "./SignInSettingsBanner";

const { Header } = Layout;

export const HeaderNav = props => {
  const { userOrg } = useContext(AuthDataContext);
  const { currentTheme } = useThemeSwitcher();
  const { navCollapsed, mobileNav, navType, headerNavColor, toggleCollapsedNav, onMobileNavToggle, isMobile, isOrgManagement } = props;

  const onToggle = () => {
    if (!isMobile) {
      toggleCollapsedNav(!navCollapsed)
    } else {
      onMobileNavToggle(!mobileNav)
    }
  }

  const isNavTop = navType === NAV_TYPE_TOP ? true : false
  const mode = () => {
    if (!headerNavColor) {
      return utils.getColorContrast(currentTheme === 'dark' ? '#000000' : '#ffffff')
    }
    return utils.getColorContrast(headerNavColor)
  }
  const navMode = mode()
  const getNavWidth = () => {
    if (isNavTop || isMobile) {
      return '0px'
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`
    } else {
      return `${SIDE_NAV_WIDTH}px`
    }
  }

  return (
    <>
      <SignInSettingsBanner />
      <Header className={`app-header ${navMode}`} style={{ backgroundColor: headerNavColor, marginTopx: '40px' }}>
        <div className={`app-header-wrapper ${isNavTop ? 'layout-top-nav' : ''}`}>
          <Logo logoType={currentTheme} />
          <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
            {!isOrgManagement && (<div className="nav-left">
              <ul className="ant-menu ant-menu-root ant-menu-horizontal">
                {
                  isNavTop && !isMobile ?
                    null
                    :
                    <li className="ant-menu-item ant-menu-item-only-child" onClick={() => { onToggle() }}>
                      {navCollapsed || isMobile ? <MenuUnfoldOutlined className="nav-icon" /> : <MenuFoldOutlined className="nav-icon" />}
                    </li>
                }
              </ul>
            </div>)}
            {userOrg && (<div className="w-100 text-center"><FreeTrialIndicator userOrg={userOrg} /></div>)}
            <div className="nav-right align-items-center">
              {!isOrgManagement && (<NavNotification currentTheme={currentTheme} />)}
              <NavOrgSelector currentTheme={currentTheme}/>
              <NavSettings />
              <NavProfile />
            </div>
          </div>
        </div>
      </Header>
    </>
  )
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, headerNavColor, mobileNav, currentTheme, direction } = theme;
  return { navCollapsed, navType, headerNavColor, mobileNav, currentTheme, direction }
};

export default connect(mapStateToProps, { toggleCollapsedNav, onMobileNavToggle })(HeaderNav);
